import { jsx as _jsx } from "react/jsx-runtime";
import Legal from '~components/legal';
const SecurityAndComplianceOverview = () => _jsx(Legal, { id: "security-and-compliance-overview" });
export default SecurityAndComplianceOverview;
